import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { FaAngleLeft } from 'react-icons/fa';

import Paths from 'paths';

import logo from 'img/logo.png';

class Header extends Component{
    render(){
        return (
            <section id="header">
                <div className={'header-wrapper'}>
                    <NavLink to={this.props.link !== undefined ? this.props.link : Paths.PATH_ADMIN_HOME } >
                        <img id={'logo'} src={logo} title={'Logo'} alt={'Logo'}/>
                    </NavLink>
                    {this.props.returnLink ? <NavLink className='header-return' to={this.props.returnLink}><FaAngleLeft/></NavLink> : ''}
                </div>
            </section>
        )
    }
}

export default Header
